import BoxInfo from '@/components/boxInfo/boxInfo';
import { Attachments } from '@/modules/move/components/attachments/attachments';
import DialogConfirmUpdateStatusForm from '@/modules/move/components/dialogConfirmUpdateStatusForm/dialogConfirmUpdateStatusForm';
import { InformationData } from '@/modules/move/components/informationData/informationData';
import TransformedDataAction from '@/modules/move/components/transformedDataAction/transformedDataAction';
import WrapperTransformedDataAction
  from '@/modules/move/components/wrapperTransformedDataAction/wrapperTransformedDataAction';
import { MOVE_STATUS_TRANSLATED } from '@/modules/move/entities/constants/move';
import { MOVE_CUSTOM_SHEET } from '@/modules/move/entities/constants/moveSheet';

import { MOVE_STATUS, MOVE_TYPE } from '@/modules/move/entities/enums/move';
import { MoveAttachment, MoveNormalized } from '@/modules/move/entities/interfaces/move';
import useMoveStatus from '@/modules/move/hooks/useMoveStatus/useMoveStatus';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import ICONS from '@/shared/entities/constants/icons';
import React, { Dispatch, ReactNode, SetStateAction, useMemo } from 'react';
import { Button } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface InformationProps {
  isLoading: boolean;
  move?: MoveNormalized;
  setMove: Dispatch<SetStateAction<MoveNormalized | undefined>>;
  transformedSheets: MoveAttachment[];
  observationSheets: MoveAttachment[];
  attachments: MoveAttachment[];
  children?: ReactNode;
}

export const Information: React.FC<InformationProps> = ({
  isLoading,
  move,
  setMove,
  transformedSheets,
  observationSheets,
  attachments,
  children,
}) => {
  const { isBrokerUser } = useCurrentUser();

  const {
    onChangeStatus,
    dialogConfirm,
    openDialogConfirmUpdateStatusForm,
    callbackDialogConfirmUpdateStatusForm,
    loadingStatus,
  } = useMoveStatus({
    move,
    onChangeStatusCallback: (status: MOVE_STATUS) => {
      setMove(
        (currentMove) =>
          ({ ...currentMove, status: MOVE_STATUS_TRANSLATED[status] }) as MoveNormalized,
      );
    },
  });

  const showTransformedObservationSheetsDownload = useMemo(() => {
    return isBrokerUser && move?.typeKey === MOVE_TYPE.DEFAULT_CREATION_STONE;
  }, [isBrokerUser, move?.typeKey]);

  return (
    <>
      {dialogConfirm}

      <DialogConfirmUpdateStatusForm
        open={openDialogConfirmUpdateStatusForm}
        fnCallback={callbackDialogConfirmUpdateStatusForm}
      />

      <BoxInfo
        title='Dados da movimentação'
        icon='info-outline'
        header={
          <Grid gap={12}>
            <Button
              loading={isLoading}
              disabled={isLoading || !move?.link}
              icon={ICONS.DOWNLOAD}
              label='Download da planilha original'
              onClick={() => (move ? window.open(move.link) : null)}
            />
            {showTransformedObservationSheetsDownload && (
              <>
                <WrapperTransformedDataAction
                  count={transformedSheets.length}
                  type={MOVE_CUSTOM_SHEET.TRANSFORMED}>
                  <TransformedDataAction
                    type={MOVE_CUSTOM_SHEET.TRANSFORMED}
                    attachments={transformedSheets}
                  />
                </WrapperTransformedDataAction>
                <WrapperTransformedDataAction
                  count={observationSheets.length}
                  type={MOVE_CUSTOM_SHEET.OBSERVATION}>
                  <TransformedDataAction
                    type={MOVE_CUSTOM_SHEET.OBSERVATION}
                    attachments={observationSheets}
                  />
                </WrapperTransformedDataAction>
              </>
            )}
          </Grid>
        }>
        <InformationData
          move={move}
          loading={isLoading}
          loadingStatus={loadingStatus}
          onChangeStatus={onChangeStatus}
        />
      </BoxInfo>

      {children}

      <Attachments attachments={attachments} />
    </>
  );
};
